export default function hasClass({ store }) {
  const classToken = localStorage.classId
  if (!classToken && store.state.credential.token) {
    store.$router.push('/class')
  }
}
